export const songColorToThumbnailImage = {
  black: "https://eleven-public-cdn.elevenlabs.io/payloadcms/ppbqqzkzbd-black.webp",
  blue: "https://eleven-public-cdn.elevenlabs.io/payloadcms/0lwq2u5ykj2-blue.webp",
  green: "https://eleven-public-cdn.elevenlabs.io/payloadcms/pewcaaejm1-green.webp",
  orange: "https://eleven-public-cdn.elevenlabs.io/payloadcms/b52mh5tmlt-orange.webp",
  purple: "https://eleven-public-cdn.elevenlabs.io/payloadcms/kdp6rvkka5n-purple.webp",
  red: "https://eleven-public-cdn.elevenlabs.io/payloadcms/h5rwzjh4h6-red.webp",
  cyan: "https://eleven-public-cdn.elevenlabs.io/payloadcms/0mmrnf4x1guk-cyan.webp",
} as const;

export const songThumbnailImageSizes = {
  height: 960,
  width: 960,
} as const;
